import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {TdoUserConfigurationModel} from '../../../models/configuration/user/tdo-user-configuration.model';
import {UserService} from '../../../services/user.service';
import {SignalrService} from '../../../services/socket/signalr.service';
import {Globals} from '../../../globals';
import {version} from '../../../../environments/version';
import {appName} from '../../../../environments/version';
import {AuthenticationResponseModel} from '../model/authentication-response.model';
import {AuthenticationService} from '../services/authentication.service';
import {LoginService} from '../login/login.service';
import {DoctorsService} from '../../../services/doctors.service';
import {LocalStorageService} from '../../../services/local-storage.service';
import {TdoImagingService} from '../../../main-interface/imaging/tdo-imaging.service';

@Component({
  selector: 'app-referrer-login',
  templateUrl: './referrer-login.component.html',
  styleUrls: ['./referrer-login.component.scss']
})
export class ReferrerLoginComponent implements OnInit {
  private returnUrl: string;
  returnParams: any = false;

  appVersion: string = '';
  appName: string = '';
  invalidCredentials:boolean=false;

  public frmCtrl = new UntypedFormControl('');
  //public pwCtrl = new UntypedFormControl('');

  public loadingLocations: boolean = true;
  public locations: any[] = [];
  public selectedLocation: string;
  public username: any;
  public pass: any;
  public validated: boolean = false;
  public isLoading: boolean = false;
  public error = '';

  constructor(private route: ActivatedRoute,
              private router: Router,
              private globals: Globals,
              private userService: UserService,
              private doctorService: DoctorsService,
              private loginService: LoginService,
              private authService: AuthenticationService,
              private localStorageService: LocalStorageService,
              private drawService: TdoImagingService,
              private signalrService: SignalrService) { }

  ngOnInit() {
    this.appVersion = version;
    this.appName = appName;

    if (localStorage.getItem('returnURL')) {
      this.returnUrl = localStorage.getItem('returnURL');
      localStorage.removeItem('returnURL');
    } else {
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    }

    if (localStorage.getItem('returnURLParameters')) {
      this.returnParams = JSON.parse(localStorage.getItem('returnURLParameters'));
      localStorage.removeItem('returnURLParameters'); 
    }

    this.loginService.getLocations()
      .subscribe(response => {
        response.forEach(location => {
          location.LOCID = `${location.LOCID}`
        });
        this.locations = response;
        this.loadingLocations = false;
      }, err => {
        console.log('err', err);
        this.loadingLocations = false;
      });
    if (typeof localStorage.getItem('LOCID') != 'undefined' && localStorage.getItem('LOCID') != 'null') {
      this.selectedLocation = localStorage.getItem('LOCID');
    }
    else {
      this.selectedLocation = '0';
    }
    // get ws mac address from service broker

    this.isServiceBrokerRunning();

  }

  isServiceBrokerRunning() {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.getWSNameWithMacAddress(() => {
            const intervalSubscription2 = setInterval(_ => {
              if (this.drawService.wsNameWithMACAddress !== '') {
                clearInterval(intervalSubscription2);
                this.globals.WorkStationName = this.drawService.wsNameWithMACAddress;
              }
            }, 100);
          });
        } else {
          clearInterval(intervalSubscription);
          this.globals.WorkStationName = 'WSTEST';
          console.log('Service Broker is not running using default workstaion name WSTEST');
          return;
        }
      }, 100);
    });
  }

  locationSelected(event) {
    localStorage.setItem('LOCID', `${event}`);
  }

  btntoken_click() {

    this.isLoading = true;
    this.invalidCredentials = false;
    this.authService.loginJwt(this.username, this.pass, this.selectedLocation, this.globals.WorkStationName, 'referring doctor')
      .subscribe((dataAuth: AuthenticationResponseModel) => {
        this.isLoading = false;
        if (dataAuth.isSuccess) {

          this.globals.LOCenumCountryId = dataAuth.locationCountryId;
          
          this.authService.storetokenResult(dataAuth);
          this.validated = true;

          this.setLoggedInUser(dataAuth);
          this.signalrService.connect();

          if (this.storeToken(dataAuth)) {
            this.validated = true;
            this.router.navigate(['/referrerportal/home']);
            return;
            } else {
            this.error = 'token not returned';
            console.log('error: ', this.error);
          }          
        } else {
          this.error = 'invalid login';
          console.log('login error: ', this.error);
          this.invalidCredentials = true;
        }
      },
        (error) => {
          this.isLoading = false;
          console.log('error: ' + error.message);
          this.error = error;
          this.invalidCredentials = true;
        });
  }

  storeToken(userInformation: any): boolean {
    const stored = this.authService.storeReferringDoctorTokenResult(userInformation);
    return stored;
  }

  getstoredToken(): string {
    return localStorage.getItem("TDOReferringDoctorAuthToken");
  }

  private setLoggedInUser(dataAuth: AuthenticationResponseModel) {
    this.userService.loggedInUser = new TdoUserConfigurationModel();
    this.userService.loggedInUser.userid = dataAuth.userId;
    this.userService.loggedInUser.UserID = dataAuth.userId;
    this.userService.loggedInUser.WorkStationID = dataAuth.workStationId;
    this.globals.WorkStationID = dataAuth.workStationId;
    this.userService.loggedInUser.TDOCID = Number(dataAuth.tdoCId);
    this.userService.loggedInUser.UserNickName = dataAuth.userNickName;
  }

  registerBtnClicked(): void {
    //this.loginEvents.emit(new LoginEvent(LoginEventType.registerBtnClicked));
  }

  forgotPasswordClicked(): void {
  }

  contactUsBtnClicked(): void {
    //this.loginEvents.emit(new LoginEvent(LoginEventType.contactUsClicked));
  }

  submitAnIssueClicked(): void {
    //this.loginEvents.emit(new LoginEvent(LoginEventType.submitAnIssueClicked));
  }

  tdoForumClickedClicked(): void {
    //this.loginEvents.emit(new LoginEvent(LoginEventType.tdoForumClicked));
  }
}
